import { type MutationHookOptions, useMutation } from "@apollo/client";
import { DeletePromocodesMutation } from "../graphql/mutations";
import type {
  DeletePromocodesMutationType,
  DeletePromocodesMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useDeletePromocodesMutation = (
  options?: MutationHookOptions<
    DeletePromocodesMutationType,
    DeletePromocodesMutationVariablesType
  >
) => {
  return useMutation<
    DeletePromocodesMutationType,
    DeletePromocodesMutationVariablesType
  >(DeletePromocodesMutation, options);
};
